import { produce } from 'immer';
import { StateCreator } from 'zustand';

import { BillingAddress, DiscountDetails, MarketingReferral, ReferralCredit } from '@/types';
interface PaymentProperties {
  paymentMethodType: 'stripe' | 'affirm';
  cardName: string;
  cardNumberComplete?: boolean;
  cardExpiryComplete?: boolean;
  cardCvcComplete?: boolean;
  billingAddress: BillingAddress;
  discount?: DiscountDetails;
  referralCredit?: ReferralCredit;
  // TODO: Discount should probably be renamed to promoCode to reduce confusion
  marketingReferral?: MarketingReferral;
  discountType?: 'promo' | 'referral';
  transactionId: string | undefined;
  finalPrice: number;
}

export interface PaymentSlice {
  payment: PaymentProperties & {
    errors: {
      [key: string]: string;
    };
    methods: {
      add: (newState: any) => void;
      remove: (field: string) => void;
      getErrors: () => { [key: string]: string };
      getAll: () => PaymentProperties;
      setError: (field: string, message: string) => void;
      clearErrors: () => void;
      removeError: (field: string) => void;
      isErrors: () => boolean;
    };
  };
  // Add payment slice types here
}

const createPaymentSlice: StateCreator<PaymentSlice> = (set, get) => ({
  payment: {
    paymentMethodType: 'stripe',
    cardName: '',
    finalPrice: 0,
    billingAddress: {
      address1: '',
      address2: '',
      city: '',
      state: '',
      postalCode: '',
      country: '',
    },
    transactionId: undefined,
    token: '',
    discount: undefined,
    referralCredit: undefined,
    errors: {},
    methods: {
      add: (newState) => {
        set(
          produce((state) => {
            state.payment = {
              ...state.payment,
              ...newState,
            };
          }),
        );
      },
      remove: (field) => {
        set(
          produce((state) => {
            delete state.payment[field];
          }),
        );
      },
      getAll: () => {
        const { errors, methods, ...properties } = get().payment;
        return properties;
      },
      getErrors: () => {
        return get().payment.errors;
      },
      setError: (field, message) => {
        set(
          produce((state) => {
            state.payment.errors[field] = message;
          }),
        );
      },
      clearErrors: () => {
        set(
          produce((state) => {
            state.payment.errors = {};
          }),
        );
      },
      removeError: (field) => {
        set(
          produce((state) => {
            delete state.payment.errors[field];
          }),
        );
      },
      isErrors: () => {
        return Object.keys(get().payment.errors).length > 0;
      },
    },
  },
});

export default createPaymentSlice;
